import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AddProductLoanLayer from "../../../components/Admin/AddProductLoanLayer";

const AddProductLoan = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <AddProductLoanLayer />
      </MasterLayout>
    </>
  );
};

export default AddProductLoan;
